import { CTA } from "common/styleguide/CTA";
import { ModalOverlay } from "common/styleguide/ModalOverlay";
import { List } from "immutable";
import p from "prop-types";
import React, { Fragment } from "react";

export const INSERT_ELEVATION_PROFILE_MODAL = "INSERT_ELEVATION_PROFILE_MODAL";

export class InsertElevationProfileModal extends React.PureComponent {
  static propTypes = {
    routeId: p.number,
    routes: p.instanceOf(List).isRequired,
    saveElevationProfile: p.func.isRequired,
    onRequestClose: p.func.isRequired,
  };

  constructor(props) {
    super(props);

    const routeId = props.routeId
      ? props.routeId
      : props.routes && props.routes.size > 0
      ? props.routes.first().id
      : null;

    this.state = {
      routeId,
      error: false,
    };
  }

  onClickSave = () => {
    const { saveElevationProfile, onRequestClose } = this.props;
    const { routeId } = this.state;

    saveElevationProfile({ routeId });
    onRequestClose();
  };

  onRouteChange = (v) => {
    this.setState({
      routeId: this.props.routes.find((r) => String(r.id) === v.target.value).id,
    });
  };

  onRequestClose = () => {
    this.props.maybeRemoveSelf(); // handles removing block if no image
    this.props.onRequestClose(); // close the modal
  };

  render() {
    const { routes } = this.props;
    const { routeId } = this.state;

    return (
      <ModalOverlay onRequestClose={this.onRequestClose} maxWidth="400px" title="Add Elevation Profile">
        <div>
          {routes.size > 0 ? (
            <Fragment>
              Choose a route:
              <form onSubmit={(e) => e.preventDefault()}>
                <select defaultValue={routeId} onChange={this.onRouteChange}>
                  {routes.map((r, idx) => (
                    <option key={idx} value={r.id}>
                      {r.name}
                    </option>
                  ))}
                </select>
              </form>
              <CTA margins={false} onClick={this.onClickSave}>
                Save
              </CTA>
              <CTA link margins={false} onClick={this.onRequestClose}>
                Cancel
              </CTA>
            </Fragment>
          ) : (
            <div style={{ margin: "20px", textAlign: "center" }}>Add a route to this experience first</div>
          )}
        </div>
      </ModalOverlay>
    );
  }
}
